import styled from "styled-components";

const StyledList = styled.ul`
 display: flex;
 flex-direction: column;
 gap: 1rem;
`;

export default StyledList;
